import React from "react";
import Cavalli from "../imgs/Cavalli Musica.png";
import Municipio4 from "../imgs/municipio 4.png";
import Municipio5 from "../imgs/municipio 5.png";

const Partners = () => {
  return (
    <div className="flex flex-col items-center z-10 xs:text-base md:text-xl ">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        PARTNERS
      </p>
      <img src={Cavalli} className="mt-2" />
      <img src={Municipio4} />
      <img src={Municipio5} />
    </div>
  );
};

export default Partners;
